export const LogoNomada = (props) => {
  /**
   * logoColor -> choose a color to show logo
   * 1 -> white
   * 2 -> orange
   * */

  const { logoColor } = props;

  return (
    <>
      {logoColor === 1 ? (
        <img
          src={"/img/bg-images/desktop/vivanomada_logo_gotas_texto.svg"}
          alt={"viva-nomada-logo-white"}
          className={"base-logo"}
        />
      ) : logoColor === 2 ? (
        <img
          src={"/img/icons/logo-vivanomada.svg"}
          alt={"viva-nomada-logo-orange"}
          className={"base-logo-search-bar"}
        />
      ) : logoColor === 3 ? (
        <img
          src={"/img/logos/logoBlanco.svg"}
          alt={"viva-nomada-logo-white"}
          className={"base-logo-setup"}
        />
      ) : logoColor === 4 ? (
        <img
          src={"/img/logos/logoBlanco.svg"}
          alt={"viva-nomada-logo-white"}
          className="base-logo-setup-login"
        />
      ) : logoColor === 5 ? (
        <img
          src={"/img/icons/vivanomada-white.svg"}
          alt={"viva-nomada-logo-white"}
          className="base-logo-search-bar"
        />
      ) : (
        <img
          src={"/img/icons/logo-vivanomada.svg"}
          alt={"viva-nomada-logo-orange"}
          className={"base-logo-search-bar"}
        />
      )}
    </>
  );
};
